import { useCallback, useState } from 'react';

type UseFindingPublishConfirmParams = {
  onPublish: () => void | Promise<void>;
};

export function useFindingPublishConfirm({
  onPublish,
}: UseFindingPublishConfirmParams) {
  const [isPublishConfirmOpen, setIsPublishConfirmOpen] = useState(false);
  const handlePublishConfirmOpenChange = useCallback(
    ({ open }: { open: boolean }) => {
      setIsPublishConfirmOpen(open);
    },
    [],
  );
  const handleConfirmPublish = useCallback(async () => {
    await onPublish();
  }, [onPublish]);

  return {
    isPublishConfirmOpen,
    setIsPublishConfirmOpen,
    handlePublishConfirmOpenChange,
    handleConfirmPublish,
  };
}
